import React, { useEffect, useRef, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { DateTimePicker, PrimaryButton, SecondaryButton, TextBox } from '../../../../../Core/FormInput';
import { addTcardNotes, getTcardNotes, deleteTcardNote } from '../../../../../Core/Service/TcardNotes-service';
import moment from 'moment';
import { Delete, Edit } from '@material-ui/icons';
import { Checkbox, FormControlLabel, FormLabel, Grid, IconButton, InputLabel } from '@material-ui/core';
import { AppStorage } from '../../../../../Core/Service/storage-service';
import formatters from '../../../../../Core/Grid/inputFormatter';

const TcardNotesModal = (props) => {
    const [state, setState] = useState({
        loading: false,
        notes: [],
        tCardNoteText: '',
        tCardNoteReminder: '',
        selectedID: null,
        editMode: false,
        showDeleteConfirm: false,
        visibleToCustomer: false
    });
    const [btnLoader, setBtnLoader] = useState(false);
    const [delBtnLoader, setDelBtnLoader] = useState(false);
    const notesContainer = useRef(null);

    const handleClose = (shouldRefresh = false) => {
        props.onClose && props.onClose(shouldRefresh);
    };

    const setNewNote = (e) => {
        const tCardNoteText = e.target.value;
        setState((prev) => ({ ...prev, tCardNoteText }));
    };

    const fieldChange = (e) => {
        let { name, value } = e.target;
        setState((st) => ({ ...st, [name]: value }));
    };

    const handleCheckbox = (event) => {
        const { name, checked } = event.target;
        setState((st) => {
            const nst = { ...st };
            nst[name] = checked;
            return nst;
        });
    };

    const deleteNoteFromServer = () => {
        setDelBtnLoader(true);
        deleteTcardNote(state.selectedID)
            .then((res) => {
                if (res.success) {
                    setState((prev) => ({
                        ...prev,
                        tCardNoteText: '',
                        selectedID: null,
                        editMode: false,
                        showDeleteConfirm: false
                    }));
                    handleClose(true); // Trigger refresh after delete
                }
            })
            .finally(() => {
                setDelBtnLoader(false);
            });
    };

    const addNotesToServer = () => {
        setBtnLoader(true);
        const noteId = state.editMode ? state.selectedID : null;
        addTcardNotes(props.tCardsID, noteId, state.tCardNoteText, state.visibleToCustomer, state.tCardNoteReminder, false)
            .then((res) => {
                if (res.success) {
                    setState((prev) => ({
                        ...prev,
                        tCardNoteText: '',
                        selectedID: null,
                        editMode: false
                    }));
                    handleClose(true); // Trigger refresh after add/edit
                }
            })
            .finally(() => {
                setBtnLoader(false);
            });
    };

    const getTcardNotesAndSaveToState = () => {
        setState((prev) => ({ ...prev, loading: true }));
        getTcardNotes(props.tCardsID)
            .then((res) => {
                if (res.success) {
                    const notes = Array.isArray(res.data.tCardNotes)
                        ? res.data.tCardNotes.map((item, index) => ({
                              ...item,
                              id: item.TCardNoteID || index + 1
                          }))
                        : [];
                    setState((prev) => ({ ...prev, notes }));
                }
                if (notesContainer.current) {
                    notesContainer.current.scrollTop = 0;
                }
            })
            .finally(() => {
                setState((prev) => ({ ...prev, loading: false }));
            });
    };

    const handleEditNote = (editMode, note) => {
        console.log('handleEditNote', note);
        setState((prev) => ({
            ...prev,
            editMode,
            tCardNoteText: note ? note.tCardNoteText : '',
            tCardNoteReminder: note.tCardNoteReminder,
            // note ? formatters.DateTimeFormatter(note.tCardNoteReminder) : '',
            visibleToCustomer: note ? note.visibleToCustomer : '',
            selectedID: editMode && note ? note.tCardNoteID : 0
        }));
    };

    const handleDeleteNote = (val, note) => {
        setState((prev) => ({
            ...prev,
            showDeleteConfirm: val,
            selectedID: note ? note.tCardNoteID : 0
        }));
    };

    useEffect(() => {
        if (props.tCardsID) {
            getTcardNotesAndSaveToState();
        }
    }, [props.tCardsID]);

    return (
        <>
            <Dialog
                open={true}
                onClose={() => handleClose(false)} // Don't refresh on simple close
                maxWidth={props.maxWidth ? props.maxWidth : 'sm'}
                className="dialog-custom job-notes-modal"
                fullWidth
            >
                <DialogTitle>
                    T-Card Notes
                    <div className="title-header-actions">
                        {!props.isReadOnly && (
                            <PrimaryButton onClick={addNotesToServer} disabled={state.tCardNoteText.trim().length === 0} isBtnLoader={btnLoader}>
                                {state.editMode ? 'Save Note' : 'New Note'}
                            </PrimaryButton>
                        )}

                        {state.editMode && (
                            <PrimaryButton
                                style={{ marginLeft: '5px' }}
                                onClick={() => handleEditNote(false)}
                                disabled={state.tCardNoteText.trim().length === 0}
                            >
                                Cancel Edit
                            </PrimaryButton>
                        )}

                        <span className="close-icon" onClick={() => handleClose(false)}>
                            &times;
                        </span>
                    </div>
                </DialogTitle>
                <DialogContent>
                    {props.modalSubHeaderTitle ? <div style={{ marginBottom: '5px' }}>{props.modalSubHeaderTitle()}</div> : null}

                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12}>
                            <InputLabel>{state.editMode ? 'Edit Note' : 'New Note'}</InputLabel>
                            <TextBox
                                // label={state.editMode ? 'Edit Note' : 'New Note'}
                                fullWidth
                                name="tCardNoteText"
                                onChange={fieldChange}
                                value={state.tCardNoteText}
                                autoFocus={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputLabel>Reminder Date</InputLabel>
                            {/* <TextBox
                                id="date" 
                                type="date"
                                name="tCardNoteReminder"
                                fullWidth
                                value={state.tCardNoteReminder}
                                onChange={fieldChange}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                InputProps={{ inputProps: { max: `${state.endDate}` } }}
                            /> */}
                            <DateTimePicker
                                style={{ marginTop: 8 }}
                                name="tCardNoteReminder"
                                value={state.tCardNoteReminder}
                                onChange={fieldChange}
                                InputProps={{ inputProps: { max: `${state.endDate}` } }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControlLabel
                                control={<Checkbox checked={state.visibleToCustomer} onChange={handleCheckbox} name="visibleToCustomer" />}
                                label="Visible To Customer?"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <div className="notes-container custom-scroll" ref={notesContainer}>
                                {state.loading && <label>Loading...</label>}
                                {state.notes.map((n, i) => (
                                    <div key={i} className="single-note">
                                        <div style={{ display: 'flex', gap: 4, justifyContent: 'space-between' }}>
                                            <span className="msg">{n.tCardNoteText}</span>
                                            {AppStorage.getCanAmendJobNotes() && !props.isReadOnly && (
                                                <span>
                                                    <IconButton size="small" onClick={() => handleEditNote(true, n)} style={{ padding: '0px' }}>
                                                        <Edit style={{ color: 'red' }} fontSize="small" />
                                                    </IconButton>
                                                    <IconButton size="small" onClick={() => handleDeleteNote(true, n)} style={{ marginRight: '5px' }}>
                                                        <Delete style={{ color: 'red' }} fontSize="small" />
                                                    </IconButton>
                                                </span>
                                            )}
                                        </div>
                                        <div className="footer">
                                            {n.by} @ {moment(n.tCardNoteDate).format('LLL')}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>

            {state.showDeleteConfirm && (
                <Dialog open={true} onClose={() => handleDeleteNote(false)} maxWidth="xs" className="dialog-custom job-notes-modal">
                    <DialogTitle>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}
                        >
                            <span>Confirm Delete Note</span>
                            <span
                                className="close-icon"
                                onClick={() => handleDeleteNote(false)}
                                style={{
                                    cursor: 'pointer',
                                    fontSize: '24px',
                                    marginLeft: '20px'
                                }}
                            >
                                &times;
                            </span>
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ display: 'flex', justifyContent: 'center' }}>
                        <SecondaryButton style={{ width: '100%', margin: '5px' }} isBtnLoader={delBtnLoader} onClick={deleteNoteFromServer}>
                            Delete
                        </SecondaryButton>
                        <SecondaryButton style={{ width: '100%', margin: '5px' }} onClick={() => handleDeleteNote(false)}>
                            Cancel
                        </SecondaryButton>
                    </DialogContent>
                </Dialog>
            )}
        </>
    );
};

export default TcardNotesModal;
